import * as angular from "angular";
import { SortState } from "../components/shared/sortable-header/sortable-header.directive";

/**
 * Persists `SortState` for sortable lists to `localStorage` under a
 * caller-supplied key. Each list page (Lists, People, …) picks its own key.
 */
export class SortPersistenceUtils {
    load(key: string): SortState {
        try {
            const raw: string | null = window.localStorage.getItem(key);
            if (!raw) {
                return this.defaultState();
            }
            const parsed: any = JSON.parse(raw);
            if (this.isValidSortState(parsed)) {
                return parsed;
            }
        } catch (_e) {
            // corrupt JSON or storage unavailable — fall through to default
        }
        return this.defaultState();
    }

    save(key: string, sort: SortState): void {
        try {
            window.localStorage.setItem(key, JSON.stringify(sort));
        } catch (_e) {
            // ignore quota / unavailable storage
        }
    }

    private defaultState(): SortState {
        return { column: null, direction: "desc" };
    }

    private isValidSortState(parsed: any): parsed is SortState {
        return (
            parsed &&
            (parsed.column === null || typeof parsed.column === "string") &&
            (parsed.direction === "asc" || parsed.direction === "desc")
        );
    }
}

angular
    .module("vcHelper")
    .service("SortPersistenceUtils", SortPersistenceUtils);
